import React from 'react';
import { validated } from 'react-custom-validation';

import { isRequired } from 'utils/validations';

import Form from 'components/Form';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Input from 'components/Input';
import ModalButton from 'components/ModalButton';
import TextArea from 'components/TextArea';

class GroupEditForm extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        group: React.PropTypes.object.isRequired,
        handleChange: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        onValid:React.PropTypes.func.isRequired,
        onInvalid:React.PropTypes.func.isRequired
    };

    render() {
        let { closeModal, handleChange, isSaving, group, onValid, onInvalid, $field, $validation } = this.props;


        return (
            <Form className="user-edit__form modal-form">
                <FormRow>
                    <Input type="text"
                           name="name"
                           placeholder="Group Name"
                           value={group.name}
                           {...$field('name', (event) => handleChange(event))} />
                    {$validation.name.show && <FormValidationMessage>{$validation.name.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormRow className="form-row">
                    <TextArea name="description"
                              placeholder="Group Description"
                              onChange={handleChange.bind(this)}
                              value={group.description} />
                </FormRow>
                <div className="modal__buttons">
                    <ModalButton disabled={isSaving === true}
                                 icon="check"
                                 onClick={(event) => {
                                     event.preventDefault();
                                     this.props.$submit(onValid, onInvalid)}}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 disabled={isSaving === true}
                                 icon="cancel"
                                 onClick={closeModal.bind(this)}
                                 text="Cancel" />
                </div>
            </Form>
        )
    }
}

function groupEditdFormValidationConfig(props) {
    const { name } = props.group;
    return {
        fields: ['name'],
        validations: {
            name: [
                [isRequired, name]
            ]
        }
    }
}

export default GroupEditForm = validated(groupEditdFormValidationConfig)(GroupEditForm);




// WEBPACK FOOTER //
// ./src/containers/UsersPage/modals/GroupEditForm.js